import React, { Component } from 'react';
import { translate } from "react-i18next";
import { sendJson, getURL } from '../../backend/Backend';
import { USER_TYPES, USER_ROLES } from '../../backend/Data';
import { Button, Row, Col, Form, Toast } from 'react-bootstrap';
import UserAdminList from "./UserAdminList";

class UserAdminDetail extends Component {

    constructor(props) {
        super(props);
        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.onEventInputChange2 = this.onEventInputChange2.bind(this);
        this.onUserUpdate = this.onUserUpdate.bind(this);
        this.search = this.search.bind(this);
        

        this.state = {
            message: '',
            user: null
        }
    }

    onEventInputChange(event) {
        const { name: fieldName, value: fieldValue } = event.target;
        let oldUser  = this.state.user;

        const newUser = {
            ...oldUser,
            [fieldName]: fieldValue
        };

        let oldState = this.state;
        this.setState({
            ...oldState,
            user: newUser
        });
    }

    onEventInputChange2(event) {
        let value = Array.from(event.target.selectedOptions, option => option.value);
        let oldUser  = this.state.user;

        const newUser = {
            ...oldUser,
            roles: value
        };
        let oldState = this.state;
        this.setState({
            ...oldState,
            user: newUser
        });
    }

    onUserUpdate() {
          sendJson('put', 'users/update', this.state.user).then(
              received => {
                if(received.ok){
                    let oldState = this.state;
                    this.setState({...oldState, message: this.state.message });
                }
              });
      }

       async search(email, id){
        if(email || id){
          let searchId= id ? id : '0';
          let searchEmail = email ? email : '0';
          const response = await fetch(getURL('users/search/' + searchId+'/'+searchEmail ))
         
          const json = await response.json();
          let oldState = this.state;
          this.setState({
            ...oldState,
            user: json
          });
        }      
        
      }


    render() {
        const { t } = this.props;
        let selectedValues = [];
        if(this.state.user ){
             selectedValues = this.state.user.roles;
        }
        
        return (<div>
              <UserAdminList search={this.search}/>
              {this.state.user && this.state.user.id ? 
                <div>
                     <Row className="mt-3">
                <Col lg={6} md={6}>
                    <Form.Control value={this.state.user.email}
                        name="email"
                        placeholder={t("email")}
                        onChange={this.onEventInputChange}
                    />
                </Col>
                <Col lg={4} md={4}>
                    <Form.Control value={this.state.user.id}
                        name="id"
                        disabled={true}
                    />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col lg={6} md={6}>
                    <Form.Control value={this.state.user.name}
                        name="name"
                        placeholder={t("name")}  onChange={this.onEventInputChange}
                    />
                </Col>
                <Col lg={4} md={4}>
                    <Form.Control as="select" name="userType" value={this.state.user.userType} onChange={this.onEventInputChange} aria-describedby="bookingHelpBlock">
                        {USER_TYPES.map((r, i) =>
                            <option key={r} value={r}>{t(r)}</option>
                        )}

                    </Form.Control>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col lg={6} md={6}>
                   
                    <Form.Control as="select" name="roles" value={selectedValues} onChange={this.onEventInputChange2} multiple>
                        {USER_ROLES.map((r, i) =>
                            <option key={r} value={r}>{t(r)}</option>
                        )}
                    </Form.Control>
                </Col>
                <Col  lg={6} md={6}>
                    
                    <Toast>
                        <Toast.Header>
                            <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                            <strong className="mr-auto">Ausgewählte Rollen </strong>
                        </Toast.Header>
                        <Toast.Body>
                            <ul>
                            {selectedValues.map((r, i) =>
                             <li key={i}>{t(r)}</li>

                        )}
                        </ul>
                        </Toast.Body>
                    </Toast>
                </Col>

            </Row>
            <Row>
                <Col>
                <Button   onClick={() => this.onUserUpdate()} className="float-right mt-1 " size="sm"><span className={ "fa fa-save mr-2" } ></span>{t("speichern")}</Button>
                </Col>
            </Row>
                </div>
                :
                "No user to show"
              }
           
           


        </div>)
    }


}
export default translate("translations")(UserAdminDetail);